import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { BaseRouteReuseStrategy, provideRouter, RouteReuseStrategy, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { queryInterceptor } from '@promojds-front/data-access';
import { ENVIRONMENT } from '@promojds-front/environments';
import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DumbErrorHandler } from '@promojds-front/errors';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { NgcCookieConsentConfig, provideNgcCookieConsent } from 'ngx-cookieconsent';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname
  },
  palette: {
    popup: {
      background: '#1E1E1E'
    },
    button: {
      background: '#4FBFFF'
    }
  },
  theme: 'edgeless',
  type: 'opt-out',
  content: {
    message: 'En utilisant notre site, vous acceptez notre  ',
    link: 'politique de cookie',
    href: '/legals/cookie',
    allow: 'Accepter',
    deny: 'Refuser',
    policy: 'Politique de cookie'
  },
  position: 'bottom-right',

};

class PromoJDSRouteReuseStrategy extends BaseRouteReuseStrategy {
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideHttpClient(
      withInterceptors([queryInterceptor])
    ),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideNgcCookieConsent(cookieConfig),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: ENVIRONMENT, useValue: environment },
    { provide: RouteReuseStrategy, useClass: PromoJDSRouteReuseStrategy },
    { provide: ErrorHandler, useClass: DumbErrorHandler }
  ]
};
